<div class="sidenav" fxLayout="column" fxLayoutAlign="space-between" fxFill>
  <div fxLayout="column" fxLayoutGap="0.5rem" fxFlex="noshrink">
    <div fxLayout="column">
      <app-main-menu-button [icon]="'dashboard'" [text]="'Dashboard'" [link]="['/tacit/dashboard']">
      </app-main-menu-button>
    </div>
    <hr />
    <div fxLayout="column">
      <app-main-menu-button [icon]="'search'" [text]="'Search Travel'" [link]="['/tacit/travel/search']">
      </app-main-menu-button>
      <app-main-menu-button [icon]="'flight_takeoff'" [text]="'Add Travel'" [link]="['/tacit/travel/add']">
      </app-main-menu-button>
      @if ((isTravelQueueViewer | async)) {
        <app-main-menu-button [icon]="'toc'" [text]="'Travel Queue'"
        [link]="['/tacit/travel/queue']"></app-main-menu-button>
      }
      @if ((isApprover | async)) {
        <app-main-menu-button [icon]="'playlist_add_check'" [text]="'Approval Queue'"
        [link]="['/tacit/travel/approval']"></app-main-menu-button>
      }
    </div>
    @if ((hasUserResource | async) || (isHousing | async)) {
      <div fxLayout="column" fxLayoutGap="0.5rem">
        <hr />
        <div fxLayout="column">
          @if ((hasUserResource | async)) {
            <app-main-menu-button [icon]="'people'" [text]="'Search Users'"
            [link]="getSearchLink()"></app-main-menu-button>
          }
          @if ((isBasicRecords | async)) {
            <app-main-menu-button [icon]="'person_add'" [text]="'Add User'"
            [link]="['/tacit/basic/add']"></app-main-menu-button>
          }
          @if ((isHousing | async)) {
            <app-main-menu-button [icon]="'home'" [text]="'Housing'"
            [link]="['/tacit/housing']"></app-main-menu-button>
          }
        </div>
      </div>
    }
    @if ((isCrisisTeam | async)) {
      <div fxLayout="column" fxLayoutGap="0.5rem">
        <hr />
        <div fxLayout="column">
          <app-main-menu-button [icon]="'phone'" [text]="'Calling Tree'" [link]="['/tacit/calling-tree']">
          </app-main-menu-button>
          <app-main-menu-button [icon]="'warning'" [text]="'Crisis Team'" [link]="['/tacit/crisis-team']">
          </app-main-menu-button>
        </div>
      </div>
    }
    @if ((isReports | async)) {
      <div fxLayout="column" fxLayoutGap="0.5rem">
        <hr />
        <div fxLayout="column">
          <app-main-menu-button [icon]="'insert_drive_file'" [text]="'Reports'" [link]="['/tacit/report']">
          </app-main-menu-button>
        </div>
      </div>
    }
  </div>
  <div fxLayout="column" fxFlex="none">
    <hr />
    <app-main-menu-button [icon]="'airplanemode_active'" [text]="'My Travel'" [link]="['/tacit/travel/me']">
    </app-main-menu-button>
    <app-main-menu-button [icon]="'person_outline'" [text]="'My Record'" [link]="['/tacit/my-record']">
    </app-main-menu-button>
    @if ((isAdmin | async)) {
      <app-main-menu-button [icon]="'settings'" [text]="'Config'"
      [link]="['/tacit/config']"></app-main-menu-button>
    }
    <app-main-menu-button [icon]="'help_outline'" [text]="'Help'" [link]="['/tacit/help']"></app-main-menu-button>
    <app-main-menu-button [icon]="'power_settings_new'" [text]="'Logout'" [link]="['/logout']"
      [showActiveLink]="false">
    </app-main-menu-button>
  </div>
</div>